<div class="faq">
  <div class="row">
    <div class="col-12">
      <div class="faq__accordion-header">
        <h1 class="faq__accordion-header-title">Frequently Asked Questions</h1>
        <button id="faq-expandCollapseToggle" class="btn faq__accordion-header-button"
        (click)="expandCollapseAllToggle()">{{expandCollapseLabel}}</button>
      </div>

      <div ngbAccordion #acc="ngbAccordion">
        <div ngbAccordionItem id="toggle-1" #item1="ngbAccordionItem">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="btn btn-link container-fluid text-left">
              <div class="faq__headerWrapper">
                <div class="faq__headerWrapper-icon">
                  <i class="vspicon-vsp_arrow_up faq__icon"
                  [ngClass]="{'vspicon-vsp_arrow_down': item1.collapsed === false}"></i>
                </div>
                <span>
                  What is 2020source?
                </span>
              </div>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              2020source is a secure website that allows approved
              providers to do business with VSP. When an account is established, users can file and save claims, view
              claim history, search for claims based on several search criteria, and update their user profile.
            </div>
          </div>
        </div>

        <div ngbAccordionItem id="toggle-2" #item2="ngbAccordionItem">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="btn btn-link container-fluid text-left">
              <div class="faq__headerWrapper">
                <div class="faq__headerWrapper-icon">
                  <i class="vspicon-vsp_arrow_up faq__icon"
                  [ngClass]="{'vspicon-vsp_arrow_down': item2.collapsed === false}"></i>
                </div>
                <span>
                  Should I use 2020source?
                </span>
              </div>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              Filing claims electronically through 2020source
              provides a quicker and more efficient submission, resulting in faster reimbursements.
            </div>
          </div>
        </div>


        @if (isLoggedIn()) {
          <div ngbAccordionItem id="toggle-3" #item3="ngbAccordionItem">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="btn btn-link container-fluid text-left">
                <div class="faq__headerWrapper">
                  <div class="faq__headerWrapper-icon">
                    <i class="vspicon-vsp_arrow_up faq__icon"
                    [ngClass]="{'vspicon-vsp_arrow_down': item3.collapsed === false}"></i>
                  </div>
                  <span>
                    How do I add other users to my account?
                  </span>
                </div>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                If you would like to add an authorized user please email
                <a appMailTo [subject]="'Authorized User Request Account ' + accountNumber()"
                [body]="'User Name:%0D%0AEmail Address:'"></a>.
              </div>
            </div>
          </div>
        }

        @if (isLoggedIn()) {
          <div ngbAccordionItem id="toggle-4" #item4="ngbAccordionItem">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="btn btn-link container-fluid text-left">
                <div class="faq__headerWrapper">
                  <div class="faq__headerWrapper-icon">
                    <i class="vspicon-vsp_arrow_up faq__icon"
                    [ngClass]="{'vspicon-vsp_arrow_down': item4.collapsed === false}"></i>
                  </div>
                  <span>
                    How do I remove a user from my account?
                  </span>
                </div>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                You can view the list of Authorized
                Users by clicking on the "Authorized Users" link in "Your Account." Click on the pencil icon, and then
                change the status from "active" to "inactive" and save using the icon. The user will receive an email
                notifying them that their account has been deactivated. Please be aware that the user name will be
                removed from your list of authorized users and if they need to be reactivated, you will need to email
                <a appMailTo [subject]="'Account ' + accountNumber()"></a>.
              </div>
            </div>
          </div>
        }

        <div ngbAccordionItem id="toggle-5" #item5="ngbAccordionItem">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="btn btn-link container-fluid text-left">
              <div class="faq__headerWrapper">
                <div class="faq__headerWrapper-icon">
                  <i class="vspicon-vsp_arrow_up faq__icon"
                  [ngClass]="{'vspicon-vsp_arrow_down': item5.collapsed === false}"></i>
                </div>
                <span>
                  Can I change my account profile?
                </span>
              </div>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              You can update or change your user information in your account profile at any time.
              Simply click on "Your Account" and modify your information. Be sure to save your changes.
              You will receive an email confirming your account information when you change the email address or
              password.
              If you need to update your office, practice, or billing information, please email <a appMailTo
            [subject]="'Account ' + accountNumber()"></a>.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-6" #item6="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item6.collapsed === false}"></i>
              </div>
              <span>
                What if I've forgotten my password?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            From the logon page, click on "Forgot Your
            Password?" Complete the information requested and click "Submit." You will receive an email with a link
            that will direct you to a screen where you can choose a new password.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-7" #item7="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item7.collapsed === false}"></i>
              </div>
              <span>
                Can I change my password?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Yes, you can change your password at any time. Click
            on "Your Account," then click on "Password."
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-8" #item8="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item8.collapsed === false}"></i>
              </div>
              <span>
                Can I change my email address?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Go to "Your Account" and re-enter a new email
            address. Click on "Save Changes." You will receive an email confirming your new email address.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-9" #item9="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item9.collapsed === false}"></i>
              </div>
              <span>
                How do I submit a claim?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Click on "Claims" in the navigation bar at the top.
            Then click “Claim Form.” Enter your Authorization number and the Date of Service to access the claim form.
            Complete all required fields in the form and click on "Submit."
            You also have the option to save the claim for later use or to reset the form to its last saved state.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-10" #item10="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item10.collapsed === false}"></i>
              </div>
              <span>
                Can I resubmit a claim?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            You can't resubmit a claim on 2020source. If you
            have questions or concerns with a claim, email
            <a appMailTo [subject]="'Account ' + accountNumber()"></a>
            for help. If you are advised to submit another claim via 2020source, you will need a new Authorization
            Number.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-11" #item11="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item11.collapsed === false}"></i>
              </div>
              <span>
                Is there a fee to file my claims?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            No. At this time, filing claims on
            2020source is free of charge.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-12" #item12="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item12.collapsed === false}"></i>
              </div>
              <span>
                How do I access my claim history on 2020source?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Click on "Claims" in the navigation bar at the top.
            There will be a dropdown menu to search by Claim Status, Date, or Last Name.
            Click on the desired search criteria, enter the required information, and click Search.
            You will now be able to view a copy of the claim.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-13" #item13="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item13.collapsed === false}"></i>
              </div>
              <span>
                How long will my claims be available in the claim history?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            You can access claims that are up to 13 months old in the claim history.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-14" #item14="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item14.collapsed === false}"></i>
              </div>
              <span>
                Who do I contact if I have questions filling out my claim form or using 2020source?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Email <a appMailTo></a>.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-15" #item15="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item15.collapsed === false}"></i>
              </div>
              <span>
                Who do I contact if I have questions about insurance coverage or reimbursement?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            For additional information or insurance related questions, email <a appMailTo></a>.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-16" #item16="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item16.collapsed === false}"></i>
              </div>
              <span>
                Why does the system take me back to the login screen?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            To protect private
            health information, you will be automatically logged out after a half hour, if you have not actively
            continued using the site. The system will reset and require you to log in again. If you have a claim
            open that you have not saved, you will lose the information you entered. Always save your claim before a
            period of inactivity on the site.

          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-18" #item18="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item18.collapsed === false}"></i>
              </div>
              <span>
                Is 2020source HIPAA compliant?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            2020source is fully HIPAA compliant. Please review the HIPAA privacy policy provided on
            <a href="https://www.vsp.com/privacy.html">VSP.com</a>.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-19" #item19="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item19.collapsed === false}"></i>
              </div>
              <span>
                What if I've forgotten my Account Number?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            If you have forgotten your Account Number, you will need to email <a appMailTo></a>
            and provide your email address.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-20" #item20="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item20.collapsed === false}"></i>
              </div>
              <span>
                What is an &quot;Insured ID Number&quot; or a &quot;Member ID Number?&quot;
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            This is the ID number assigned by VSP to the person that is the main subscriber on the insurance policy.
            If your patient is not the VSP insured member (a spouse, child, etc.), please use the ID number of the
            person listed as the VSP member when asked for either the "Insured ID Number" or the "Member ID
            Number."
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-21" #item21="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item21.collapsed === false}"></i>
              </div>
              <span>
                What are the CPT/HCPCS codes I need to use on the claim form?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            The Healthcare Common Procedure Coding System (HCPCS) is a set of health care procedure codes based on
            the American Medical Association's Current Procedural Terminology (CPT). These codes are used for the
            services and materials you provide to your patients. Their use is legally required to ensure consistent
            insurance claims processing. You can order CPT and HCPCS code books by calling
            <strong>800.MED.SHOP</strong>.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-22" #item22="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item22.collapsed === false}"></i>
              </div>
              <span>
                How do I find a claim I saved to complete later?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Click on "Claims" in the navigation bar at the top.
            There will be a dropdown menu to search by Claim Status, Date, or Last Name.
            Click on the desired search criteria, enter the required information, and click Search.
            You will now be able to view a copy of the claim.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-23" #item23="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item23.collapsed === false}"></i>
              </div>
              <span>
                How long will it take VSP to process my claim and send my reimbursement?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Claims are normally processed within five business days from the date VSP receives the claim. You will
            receive your reimbursement according to our normal payment cycle.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-24" #item24="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item24.collapsed === false}"></i>
              </div>
              <span>
                When I'm filling out a claim form on 2020source, can I use the word &quot;SAME&quot; instead of
                repeating patient and address information?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            No. Using the word "SAME" in any field will result in claim processing errors. You must complete each
            required field with accurate information.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-25" #item25="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item25.collapsed === false}"></i>
              </div>
              <span>
                How do I check my VSP patient's benefits online?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Always check your VSP patients’ eligibility and coverage before providing services to the patient.
            Once you have logged in to your account, simply click on "Patient Search" and complete the required
            fields.
          </div>
        </div>
      </div>

      <div ngbAccordionItem id="toggle-26" #item26="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="btn btn-link container-fluid text-left">
            <div class="faq__headerWrapper">
              <div class="faq__headerWrapper-icon">
                <i class="vspicon-vsp_arrow_up faq__icon"
                [ngClass]="{'vspicon-vsp_arrow_down': item26.collapsed === false}"></i>
              </div>
              <span>
                What is a &quot;coordination of benefit claim&quot; and how do I note this on the claim form to
                VSP?
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            Your VSP patient may ask you to coordinate their claim with another insurance carrier. This means that
            the patient has additional vision coverage by VSP or another carrier, and wishes to use plan benefits
            from both plans. Please refer to the Reference Guide: Coordinating Benefits on 2020source under the
            Provider Manual and Self Service Tools link for more information.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
